<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2023-12-20 16:53:36
!-->
<template>
  <div id="index" class="index">
    <div
      class="bannerLogo"
      style="max-width: 100%; min-width: 1240px; margin: auto"
    >
      <div class="title-one">{{ $t('home.titleone') }}</div>
      <div class="title-two">{{ $t('home.titletwo') }}</div>
    </div>
    <div
      class="paddTop250"
      style="
        display: flex;
        justify-content: center;
        margin-top: calc(-172px + 16px);
      "
    >
      <div>
        <div class="check-title">
          <div class="check-title-item" @click="goto('/')">{{ $t('route.allTitle') }}</div>
          <div class="check-title-item " @click="goto('/exp')">{{ $t('route.expTitle') }}</div>
          <div class="check-title-item" @click="goto('/fba')">{{ $t('route.fbaTitle') }}</div>
          <div class="check-title-item active" @click="goto('/air')">{{ $t('route.airTitle') }}</div>
          <div class="check-title-item" @click="goto('/sea')">{{ $t('route.seaTitle') }}</div>
        </div>
        <CheckPrice ref="CheckPrice" @step="step" />
      </div>
    </div>
    <!-- 查价结果 -->
    <div v-if="isShowResult" class="results-main">
      <Results ref="Results" :data="list" :input-data="inputData" />
    </div>
    <div v-if="isNoData">
      <NoResults :calculationSource="2" />
    </div>
  </div>
</template>

<script>
import NoResults from '@/client/home/noResults.vue'
import Steps from '@/client/home/steps.vue'
import Results from '@/client/home/results/index.vue'
import CheckPrice from '@/client/home/checkPrice/Air/checkPrice.vue'
import { setCookie } from '@/utils/cookiejs'
import { Activate } from '@/api/user.js'
export default {
  name: 'Index',
  components: {
    // 组件的引用
    CheckPrice,
    Results,
    Steps,
    NoResults
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      navTopAtv: false,
      isSteps: false, // 是否显示进度条
      active: 5,
      isShowResult: false, // 是否显示结果
      cId: '', // 客户id
      list: [],
      inputData: null,
      isNoData: true
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
    document.getElementsByTagName('body')[0].style.backgroundColor = '#F5F7FA'
  },
  destroyed() {
    // 页面销毁时加载内容
    document.getElementsByTagName('body')[0].style.backgroundColor = '#fff'
  },
  methods: {
    // 方法
    step(isOk, val, data, inputData) {
      this.active = val
      console.log(this.active)
      this.isSteps = isOk
      this.isNoData = false
      if (val === 0) {
        this.isSteps = false
      } else {
        this.isSteps = true
      }
      if (data) {
        if (data.list.length === 0) {
          this.isNoData = true
          this.isShowResult = false
        } else {
          this.isShowResult = true
          this.$nextTick(() => {
            this.$refs.Results.init(data, inputData)
          })
        }
      } else {
        this.isNoData = false
        this.isShowResult = false
      }
      this.$nextTick(() => {
        this.$refs.CheckPrice.init(val)
        if (inputData) {
          this.$refs.CheckPrice.checkprice(inputData, false)
        }
      })
    },
    goToManage() {
      const nativeHref = this.$router.resolve({
        path: `manage`
        // query,
      })
      // checkPriceLink(this, nativeHref.href, true);
      const w = window.open()
      w.location.href = nativeHref.href
    },
    // 获取页面参数
    getQueryString(key) {
      // 创建 URLSearchParams 对象并传入当前页面的 URL
      const params = new URLSearchParams(window.location.hash.split('?')[1])

      // 通过 get() 方法获取指定参数名称的值
      return params.get(key) // 'paramName'为要获取的参数名称
    },
    // 客户激活
    activate() {
      Activate(this.cId).then((res) => {
        setCookie('token', res.data)
        window.location.href = window.location.hash.split('?')[0]
      })
    },
    goto(url) {
      this.$router.push({ path: url })
    }
  }
}
</script>
<style scoped lang="scss">
.index {
  margin-top: -64px;
  .paddTop250 {
    padding-top: 100px;
  }

  .bannerLogo {
    width: auto;
    height: 240px;
    background: url('../../../../assets/img/pic_banner@2x.png');
    background-size: cover;

    .title-one {
      margin: 0 auto;
      width: 1200px;
      padding-top: 116px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: bold;
      font-size: 24px;
      color: #333333;
      line-height: 32px;
      text-align: left;
      font-style: normal;
      box-sizing: border-box;
    }

    .title-two {
      margin: 0 auto;
      width: 1200px;
      padding-top: 4px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #777777;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      box-sizing: border-box;
    }

    .steps-class {
      width: 1000px;
      text-align: left;
      margin: 0 auto;

      ::v-deep .el-steps {
        .el-step {
          z-index: 0;

          .is-process {
            .el-step__icon {
              background: #e95506 !important;
            }
          }

          .is-finish {
            color: #e95506;
            border-color: #e95506;

            .el-step__icon {
              background: rgba(233, 85, 6, 0.64) !important;
            }

            .el-step__line {
              background-color: #e95506 !important;
            }
          }

          .el-step__head {
            .el-step__line {
              margin: 5px 64px;
              left: -21px;
              right: 9px;
            }

            .el-step__icon {
              width: 32px;
              height: 32px;
              background: rgba(255, 255, 255, 0.16); //rgba(233,85,6,0.64);
              font-size: 18px;
              font-family: AppleSystemUIFont;
              color: rgba(255, 255, 255, 0.64);
              border: 0;
            }
          }

          .el-step__main {
            .is-process {
              color: #ffffff !important;
            }

            .is-finish {
              color: rgba(255, 255, 255, 0.64) !important;
            }
          }
        }

        .el-step:nth-of-type(2) {
          .el-step__main {
            position: relative;
            left: -71px;
          }
        }
      }
    }
  }

  .results-main {
    margin: 24px auto;
    width: 1200px;
    text-align: center;
  }

  .check-title{
  	width: 1200px;
  	display: flex;
  	justify-content: center;
  	background-color: rgba(255, 255, 255, 0.5);
  	border-radius: 6px 6px 0 0;
  	height: 56px;

  	.check-title-item{
  		color: #777777;
  		font-size: 14px;
  		line-height: 50px;
  		height: 50px;
  		margin-left: 39px;
  		cursor: pointer;
  		font-weight: 500;
  		font-style: normal;
  	}
  	.active{
  		color: #3370FF;
  		font-weight: 500;
  		border-bottom: 2px solid #3370ff ;

  	}
  }
}
</style>
